module.exports = __webpack_public_path__ + "media/images/operation_jobs/door_close_dryer-c1155ea3bd82eab4f8c5ca69267991c8.gif";